import React, { useContext } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import a11yProps from "./a11yProps";
import ClientNotes from "../ClientNotes";
import TabPanel from "./TabPanel";
import DataContext from "../../../../../../context/DataContext";
import PropTypes from 'prop-types';


export const TabClientNotes = React.memo(function ClientNotesComponent({
  caseObj,
}) {
  const { casePk } = useContext(DataContext);

  return (
    <div className="flex flex-col flex-1 bg-white rounded-xl shadow-[3px_3px_10px_0px_rgb(188,209,255)] mt-6">
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          padding: "0",
        }}
      >
        <Tabs
          value={0}
          aria-label="client notes tab"
          className="justify-between"
          variant="fullWidth"
          TabIndicatorProps={{ sx: { backgroundColor: "#9333EA" } }}
          sx={{
            "& button.Mui-selected": {
              color: `#9333EA`,
            },
            ".Mui-selected": {
              color: `#9333EA`,
            },
            ".MuiBox-root.div": {
              padding: 0,
            },
          }}
        >
          <Tab 
            label={"Client Notes"} 
            {...a11yProps(0)} 
            className={"w-full"}
          />
        </Tabs>
      </Box>
      
      <TabPanel value={0} index={0} className="flex-1">
          <ClientNotes caseObj={!caseObj ? "" : {...caseObj, pk: !caseObj ? casePk : caseObj.pk}}/>
      </TabPanel>
    </div>
  );
});

TabClientNotes.propTypes = {
    caseObj: PropTypes.shape({
      pk: PropTypes.number.isRequired
    }).isRequired,
  };